import { useEffect, useState } from 'react';
import { fetchHospitals } from '../services/hospitalApi';
import type { Hospital as ApiHospital } from '../services/hospitalApi/hospitalApi.types';
import { Hospital } from '../types/entities';
import { useApi } from './useApi';

/**
 * API型からコンポーネント型へのマッピング関数
 */
const mapApiHospitalToHospital = (apiHospital: ApiHospital): Hospital => ({
  id: typeof apiHospital.id === 'string' ? parseInt(apiHospital.id, 10) : apiHospital.id as number,
  name: apiHospital.name,
  address: apiHospital.address,
  phone: apiHospital.phone,
  website: apiHospital.website,
  created_at: apiHospital.created_at,
  updated_at: apiHospital.updated_at
});

/**
 * 病院情報を取得するためのカスタムフック
 */
export const useHospital = () => {
  const [hospitals, setHospitals] = useState<Hospital[]>([]);

  // API呼び出しのフックを利用
  const fetchHospitalsApi = useApi(
    async () => {
      const data = await fetchHospitals();
      return data;
    },
    {
      errorMessage: '病院情報の取得に失敗しました',
      onSuccess: (data) => {
        // API型からコンポーネント型への変換
        const mappedData = data.map(mapApiHospitalToHospital);
        setHospitals(mappedData);
      }
    }
  );

  // 初期ロード時に病院情報を取得
  useEffect(() => {
    fetchHospitalsApi.execute();
  }, []);

  // 病院名を取得する関数
  const getHospitalNameById = (hospitalId?: number): string => {
    if (!hospitalId) return '未設定';
    
    const hospital = hospitals.find(h => h.id === hospitalId);
    return hospital ? hospital.name : '未設定';
  };

  return {
    hospitals,
    isLoading: fetchHospitalsApi.loading,
    error: fetchHospitalsApi.error,
    getHospitalNameById,
    refreshHospitals: fetchHospitalsApi.execute
  };
}; 